import { Typography, TypographyProps } from '@mui/material';

export default function MultiLineTypography({
	text,
	...props
}: { text: string } & TypographyProps) {
	const typographySx = Array.isArray(props.sx)
		? [{ minWidth: 0, maxWidth: '100%', overflowWrap: 'anywhere', whiteSpace: 'break-spaces' }, ...props.sx]
		: [{ minWidth: 0, maxWidth: '100%', overflowWrap: 'anywhere', whiteSpace: 'break-spaces' }, props.sx];

	return (
		<Typography {...props} sx={typographySx}>
			{text}
		</Typography>
	);
}
